import React from 'react';

import LinkBranded from 'elements/links/Link.branded';
import { MightyHostsBannerWrapper } from 'elements/resourceCenter/MightyHostsBanner.styles';
import Heading from 'elements/typography/heading';
import Paragraph from 'elements/typography/paragraph';

const MightyHostsBanner = (): JSX.Element => {
  return (
    <MightyHostsBannerWrapper>
      <Heading size="40px"
               align="center"
               level={3}
               text="Join Mighty Hosts"/>

      <Paragraph size="18px"
                 align="center"
                 weight="light"
                 text="For creators and entrepreneurs who are leveling up their online businesses with a Mighty Network."/>

      <LinkBranded text="Join Now" url="https://new.mn.co/?plan=free-trial"/>
    </MightyHostsBannerWrapper>
  );
};

export default MightyHostsBanner;
